var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.7128 7.43108L0.913011 0.0978286C0.822045 0.0360615 0.717912 0.00233463 0.611323 0.000116903C0.504734 -0.00210083 0.399537 0.0272708 0.306554 0.0852106C0.213571 0.14315 0.136159 0.227566 0.0822796 0.329775C0.0284005 0.431984 4.80177e-08 0.548295 0 0.666745V15.3333C4.80177e-08 15.4517 0.0284005 15.568 0.0822796 15.6702C0.136159 15.7724 0.213571 15.8568 0.306554 15.9148C0.399537 15.9727 0.504734 16.0021 0.611323 15.9999C0.717912 15.9977 0.822045 15.9639 0.913011 15.9022L11.7128 8.56892C11.8006 8.50936 11.873 8.42576 11.9233 8.32614C11.9736 8.22652 12 8.11422 12 8C12 7.88578 11.9736 7.77348 11.9233 7.67386C11.873 7.57424 11.8006 7.49064 11.7128 7.43108Z","fill":"#22202F"}));
}

PlayIcon.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
